import TagBadge from "./TagBadge";

interface Props {
  allTags: Array<{ tag: string; count: number }>;
  selected: string[];
  onToggle: (tag: string) => void;
  onClear: () => void;
}

export default function TagFilter({ allTags, selected, onToggle, onClear }: Props) {
  if (allTags.length === 0) return null;

  return (
    <div className="mb-4 flex flex-wrap items-center gap-2 rounded-md border border-washiDeep bg-white px-3 py-2">
      <span className="text-xs font-medium text-navySoft">タグで絞り込み:</span>
      {allTags.map(({ tag, count }) => (
        <TagBadge
          key={tag}
          tag={`${tag} (${count})`}
          size="sm"
          selected={selected.includes(tag)}
          onClick={() => onToggle(tag)}
        />
      ))}
      {selected.length > 0 && (
        <button
          type="button"
          onClick={onClear}
          className="ml-auto text-xs text-inkLight underline hover:text-navy"
        >
          フィルタ解除
        </button>
      )}
    </div>
  );
}
